export default __webpack_public_path__ + "static/media/Communicate_disabled.31e6d54c.jpg";